export default "__VITE_ASSET__nO2eqzfW__"